import global$1 from './global.js';
import isCallable$1 from './is-callable.js';
import inspectSource$1 from './inspect-source.js';

var global = global$1;
var isCallable = isCallable$1;
var inspectSource = inspectSource$1;
var WeakMap = global.WeakMap;
var nativeWeakMap = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));

export { nativeWeakMap as default };
